import React from 'react';
import s from './ColumnsInfoSection.scss';
import {ColumnsInfoItem} from './InfoSectionColumn/ColumnsInfoItem';
import {InfoSectionProps} from '../../InfoSectionLayout';
import {IProductInfo} from '@wix/wixstores-graphql-schema';
import classNames from 'classnames';
import {withGlobalProps} from '../../../../providers/globalPropsProvider';

export enum DataHook {
  ColumnsInfoSection = 'columns-info-section',
}

export interface ColumnsInfoSectionProps extends InfoSectionProps {
  infoSectionItems: IProductInfo[];
  numberOfColumns: number;
  isRTL?: boolean;
}

class ColumnsInfoSectionBase extends React.Component<ColumnsInfoSectionProps> {
  public render(): JSX.Element {
    const {infoSectionItems, numberOfColumns, isRTL, globals} = this.props;
    const isProductPageUpliftEnabled = globals?.experiments?.productPageUplift;
    let calcNumberOfColumns = numberOfColumns;
    if (numberOfColumns === 3 && infoSectionItems.length < 3) {
      calcNumberOfColumns = 2;
    }
    if (numberOfColumns >= 2 && infoSectionItems.length < 2) {
      calcNumberOfColumns = 1;
    }

    return (
      <ul
        data-hook={DataHook.ColumnsInfoSection}
        className={classNames(s.columns, {[s.responsiveLayout]: isProductPageUpliftEnabled})}
        dir={isRTL ? 'rtl' : 'ltr'}>
        {infoSectionItems.map((infoItem, index) => {
          return (
            <ColumnsInfoItem
              key={infoItem.id}
              description={infoItem.description}
              title={infoItem.title}
              index={index}
              numberOfColumns={calcNumberOfColumns}
            />
          );
        })}
      </ul>
    );
  }
}

export const ColumnsInfoSection = withGlobalProps(ColumnsInfoSectionBase);
